var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"cell-unit",on:{"click":_vm.onClick}},[_c('img',{staticClass:"cell-unit-icon",attrs:{"src":[_vm.isValid ? _vm.validIconSRC : _vm.inValidIconSRC]}}),_c('p',{staticClass:"cell-unit-title",class:{ disable: !_vm.isValid }},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }